import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { fetcher } from 'api/client';
import { login } from 'api/actions/auth';
import { useSign, CONTROL_MODAL, LOGIN_MODAL, SET_JWT } from 'context/signview';
import { toast } from 'components/Shared/Toast';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, Media, ButtonGroup } from 'reactstrap';

export default function Login() {
    const [{ modal, profile }, dispatch] = useSign();

    const { t } = useTranslation();

    const queryClient = useQueryClient();
    const password = useRef();

    const { mutate: loginMutation } = useMutation((payload) => fetcher(login(payload)), {
        onSuccess: ({ jwt }) => {
            localStorage.setItem('jwt', jwt);
            dispatch({ type: SET_JWT, jwt })
            queryClient.invalidate('client-profile');
            toast.error(t('loggedin'))
            handleClose();
        }, onError: ({ message }) => {
            toast.error(t(`errors.${message}`))
        }
    })

    const handleClose = () => {
        dispatch({ type: CONTROL_MODAL, close: LOGIN_MODAL });
    }

    const handleLogin = () => {
        const value = password.current.value
        if (value) {
            loginMutation({ email: profile.email, password: value })
        }
    }

    return (
        <Modal isOpen={modal.includes(LOGIN_MODAL)} centered>
            <ModalHeader toggle={handleClose}>
                {t('sign.contract.banner_login_action')}
            </ModalHeader>
            <ModalBody>
                <Media>
                    <Media left className="align-self-center mr-2">
                        <img src="/images/owl-logo.svg" width="70px"></img>
                    </Media>
                    <Media body>
                        <Label>{t('sign.contract.user')}: <b>{profile.email}</b></Label>
                        <Input
                            type="password"
                            placeholder={t('sign.contract.passwordPlaceholder')}
                            id="userpassword"
                            innerRef={password} />
                    </Media>
                </Media>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button
                        color="light"
                        onClick={handleClose}>
                        {t('common.cancel')}
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleLogin}>
                        {t('sign.contract.banner_login_action')}
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal >
    )
}